import {
  type DynamicConfigName,
  type DynamicConfigValue,
  useDynamicConfig as useCoreDynamicConfig,
} from '@funkit/connect-core'

import { useUserIpInfo } from '../geo/useUserIpInfo'

// RN counterpart of `@funkit/connect`'s `hooks/statsig/useDynamicConfig`. The
// core hook takes `countryCode` as a parameter so it stays platform-agnostic;
// this wrapper threads the user's IP-derived `alpha2` (Moonpay/ipapi) so
// country-conditional variant configs (e.g. `enableswappeddeposit`) resolve
// against the real region instead of falling to their default branch.
export type { DynamicConfigName, DynamicConfigValue }

export const useDynamicConfig = <Name extends DynamicConfigName>(
  name: Name,
  options?: {
    bypassCountryCode?: boolean
  },
): DynamicConfigValue<Name> => {
  const { userIpInfo } = useUserIpInfo()
  return useCoreDynamicConfig(name, {
    bypassCountryCode: options?.bypassCountryCode,
    countryCode: userIpInfo?.alpha2,
  })
}
